// extracted by mini-css-extract-plugin
export var body = "style-module--body--35926";
export var container = "style-module--container--56e54";
export var content = "style-module--content--8ac41";
export var dashboardShell = "style-module--dashboardShell--040c4";
export var fullWidth = "style-module--fullWidth--bda17";
export var headerContainer = "style-module--headerContainer--77a50";
export var headerContent = "style-module--headerContent--8efd9";